import Transformer from "./Transformer";
import _ from "lodash";

export default class ResolutionTransformer extends Transformer {
  static getResolutionData(response) {
    if (!_.isEmpty(response)) {
      return {
        template_id: response.id,
        symptoms: [],
        isCompleted: response.isCompleted ? response.isCompleted : false,
        protocol: {
          pages: this.getPageResponse(response.protocol.pages)
        }
      };
    }
  }

  static getUpdatedResolutionData(response, actionType) {
    if (!_.isEmpty(response)) {
      return {
        symptoms:  actionType === 'alert' ? response.alert.map(item => {
                                              return item.alert_id;
                                            })
                                          : response.symptoms.map(item => {
                                              return item.id;
                                            }),
        template_id: response.management_protocol_template_id,
        updated_at: response.updated_at,
        resolved_alert_id: response.id,
        isCompleted: response.isCompleted ? response.isCompleted : false,
        protocol: {
          pages: this.getPageResponse(response.content.pages)
        }
      };
    }
  }

  static getPageResponse(pages) {
    const pagesData = [];
    pages.map(page => {
      pagesData.push({
        pageTitle: page.pageTitle,
        pageOrder: page.pageOrder,
        options: this.getPageOptions(page.options)
      });
    });
    return pagesData;
  }

  static getPageOptions(options) {
    const pageOptions = [];
    options &&
      options.map(option => {
        pageOptions.push({
          title: option.title,
          type: option.type,
          value: option.value
            ? option.value
            : option.type !== "checkbox"
            ? ""
            : [],
          choices:
            option.type === "textarea"
              ? undefined
              : this.getChoices(option.choices)
        });
      });
    return pageOptions;
  }

  static getChoices(response) {
    const choices = [];
    response &&
      response.map(choice => {
        choices.push({
          title: choice.title,
          value: choice.value,
          key: choice.key
        });
      });
    return choices;
  }
}
